"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _GraphTitle = require("../GraphTitle");

var _Loader = require("../Loader");

var _LazyCharts = require("../LazyCharts");

var _utils = require("../utils");

var _AnalyticsDateFormatter = _interopRequireDefault(require("../AnalyticsDateFormatter"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var UniqueViewsOfHelpfulContentOverTime = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(UniqueViewsOfHelpfulContentOverTime, _Component);

  var _super = _createSuper(UniqueViewsOfHelpfulContentOverTime);

  function UniqueViewsOfHelpfulContentOverTime(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UniqueViewsOfHelpfulContentOverTime);
    _this = _super.call(this, props);

    _this.setState({
      isLoading: true,
      viewsOverTime: [],
      uniqueUsersRaisedTickets: []
    });

    return _this;
  }

  (0, _createClass2.default)(UniqueViewsOfHelpfulContentOverTime, [{
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(prevProps) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.props.startDate !== prevProps.startDate || this.props.endDate !== prevProps.endDate || this.props.selectedRoles !== prevProps.selectedRoles || this.props.selectedContentTypes !== prevProps.selectedContentTypes || this.props.selectedCategories !== prevProps.selectedCategories)) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return this.fetchGraphData();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidUpdate(_x) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "fetchGraphData",
    value: function () {
      var _fetchGraphData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _yield$Promise$all, _yield$Promise$all2, uniqueViewsOfHelpfulContent, uniqueUsersRaisedTickets;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setState({
                  isLoading: true
                });
                _context2.prev = 1;
                _context2.next = 4;
                return Promise.all([this.fetchUniqueViewsOfHelpfulContentOverTime(), this.fetchUniqueUsersRaisedTicketsOverTime()]);

              case 4:
                _yield$Promise$all = _context2.sent;
                _yield$Promise$all2 = (0, _slicedToArray2.default)(_yield$Promise$all, 2);
                uniqueViewsOfHelpfulContent = _yield$Promise$all2[0];
                uniqueUsersRaisedTickets = _yield$Promise$all2[1];
                this.setState({
                  viewsOverTime: uniqueViewsOfHelpfulContent.data,
                  uniqueUsersRaisedTickets: uniqueUsersRaisedTickets.data,
                  isLoading: false
                });

              case 9:
                _context2.prev = 9;
                this.setState({
                  isLoading: false
                });
                return _context2.finish(9);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1,, 9, 12]]);
      }));

      function fetchGraphData() {
        return _fetchGraphData.apply(this, arguments);
      }

      return fetchGraphData;
    }()
  }, {
    key: "fetchUniqueViewsOfHelpfulContentOverTime",
    value: function () {
      var _fetchUniqueViewsOfHelpfulContentOverTime = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.props.fetchData('/analyticsV2/uniqueViewsOfHelpfulContentOverTime');

              case 2:
                return _context3.abrupt("return", _context3.sent);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchUniqueViewsOfHelpfulContentOverTime() {
        return _fetchUniqueViewsOfHelpfulContentOverTime.apply(this, arguments);
      }

      return fetchUniqueViewsOfHelpfulContentOverTime;
    }()
  }, {
    key: "fetchUniqueUsersRaisedTicketsOverTime",
    value: function () {
      var _fetchUniqueUsersRaisedTicketsOverTime = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.props.fetchData('/analyticsV2/uniqueUsersRaisedTicketsOverTime');

              case 2:
                return _context4.abrupt("return", _context4.sent);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function fetchUniqueUsersRaisedTicketsOverTime() {
        return _fetchUniqueUsersRaisedTicketsOverTime.apply(this, arguments);
      }

      return fetchUniqueUsersRaisedTicketsOverTime;
    }()
  }, {
    key: "render",
    value: function render() {
      var shouldChartRedraw = this.props.shouldChartRedraw;
      var _this$state = this.state,
          isLoading = _this$state.isLoading,
          viewsOverTime = _this$state.viewsOverTime,
          uniqueUsersRaisedTickets = _this$state.uniqueUsersRaisedTickets;
      return (0, _preact.h)("div", {
        className: "graph-row"
      }, (0, _preact.h)(_GraphTitle.GraphTitle, {
        customClass: "with-legend",
        title: "Self-service and helpdesk user trends",
        tooltipMessage: "Unique visitors who viewed help content and unique users who created tickets over time."
      }), isLoading ? (0, _preact.h)(_Loader.Loader, null) : (0, _preact.h)(_LazyCharts.Bar, {
        redraw: shouldChartRedraw,
        data: {
          datasets: [{
            label: 'Unique visitors who viewed help content',
            fill: false,
            data: viewsOverTime.map(function (d) {
              return {
                x: d.time,
                y: d.count
              };
            }),
            backgroundColor: _utils.BRAND_BLUE
          }, {
            label: 'Unique users that submit a ticket',
            fill: false,
            data: uniqueUsersRaisedTickets.map(function (d) {
              return {
                x: d.time,
                y: d.count
              };
            }),
            backgroundColor: _utils.BRAND_YELLOW
          }]
        },
        options: {
          title: {
            display: false
          },
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 24
            }
          },
          responsive: true,
          maintainAspectRatio: false,
          tooltips: {
            intersect: false,
            mode: 'x',
            callbacks: {
              title: function title(item) {
                if (item.length > 0 && item[0].label) {
                  var date = new Date(item[0].label.substr(0, 10));
                  return _AnalyticsDateFormatter.default.getMonthAndDayForChartTooltip(date);
                }

                return '';
              }
            }
          },
          legend: {
            display: true,
            position: 'top',
            align: 'start',
            labels: {
              boxWidth: 12
            }
          },
          scales: {
            xAxes: [{
              type: 'time',
              offset: true,
              time: {
                minUnit: 'day'
              },
              gridLines: {
                display: false
              },
              ticks: {
                maxRotation: 0,
                callback: function callback(value) {
                  return "      ".concat(value, "      ");
                }
              }
            }],
            yAxes: [{
              gridLines: {
                borderDash: [8, 4],
                color: _utils.BRAND_BORDER_GREY,
                drawBorder: false
              },
              ticks: {
                padding: 16,
                beginAtZero: true
              }
            }]
          },
          plugins: {
            datalabels: {
              display: false
            }
          }
        }
      }));
    }
  }]);
  return UniqueViewsOfHelpfulContentOverTime;
}(_preact.Component);

var _default = UniqueViewsOfHelpfulContentOverTime;
exports.default = _default;